import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ja from 'vuetify/src/locale/ja';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    
    themes: {
      light: {
        primary: '#8A56AC'
      },
      
      dark: {
        primary: '#8A56AC',
        secondary: '#9599B3',
        info: '#868AA1'
      }
    },
    
    options: {
      customProperties: true,
    },
  },
  lang: {
    locales: { ja },
    current: 'ja',
  },
});
